import React from 'react';
import { Card, Avatar, Tag, Typography, Space, Rate } from 'antd';
import { UserOutlined } from '@ant-design/icons';

const { Text } = Typography;

interface Coach {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  status: string;
  specializations: string[];
  performanceRating: number;
  assignedClients: number;
}

interface CoachCardProps {
  coach: Coach;
  onEdit?: (coach: Coach) => void;
  onViewDetails?: (coach: Coach) => void;
  size?: 'default' | 'small' | 'large';
}

const CoachCard: React.FC<CoachCardProps> = ({ 
  coach, 
  onEdit, 
  onViewDetails, 
  size = 'default' 
}) => {
  return (
    <Card
      size="small"
      hoverable
      onClick={() => onViewDetails?.(coach)}
      style={{ marginBottom: 8 }}
    >
      <Space align="start" style={{ width: '100%' }}>
        <Avatar icon={<UserOutlined />} size="large" />
        <div style={{ flex: 1 }}>
          <Text strong>{coach.firstName} {coach.lastName}</Text>
          <br />
          <Text type="secondary">{coach.email}</Text>
          <br />
          <Space size="small">
            <Tag color={coach.status === 'Active' ? 'green' : 'red'}>{coach.status}</Tag>
            <Rate disabled defaultValue={coach.performanceRating} count={5} style={{ fontSize: 12 }} />
          </Space>
          <br />
          <Text type="secondary">{coach.assignedClients} clients</Text>
        </div>
      </Space>
    </Card>
  );
};

export default CoachCard; 